import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux';
import { AnimationWrapper } from './views/animate';
import { Background } from './components/Background';
import { VehicleRegistration } from './views/VehicleRegistration';

const LayoutComponent = () => (
	<Provider store={store}>
		<AnimationWrapper>
			<Background />
			<VehicleRegistration />
		</AnimationWrapper>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.VehicleRegistration)
	.setTransitionTime(600)
	.build();

export default Layout;
